var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.proceed.apply(null, arguments)
        },
        keydown: function ($event) {
          return _vm.postForm.errors.clear($event.target.name)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v(_vm._s(_vm.trans("blog.title")))]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.postForm.title,
                expression: "postForm.title",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              name: "title",
              placeholder: _vm.trans("blog.title"),
            },
            domProps: { value: _vm.postForm.title },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.postForm, "title", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("show-error", {
            attrs: { "form-name": _vm.postForm, "prop-name": "title" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-6 form-group" },
          [
            _c("label", [_vm._v(_vm._s(_vm.trans("blog.slug")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.postForm.slug,
                  expression: "postForm.slug",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "slug",
                placeholder: "auto-from-title",
              },
              domProps: { value: _vm.postForm.slug },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.postForm, "slug", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("show-error", {
              attrs: { "form-name": _vm.postForm, "prop-name": "slug" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-6 form-group" },
          [
            _c("label", [_vm._v(_vm._s(_vm.trans("blog.category")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.postForm.category,
                  expression: "postForm.category",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "category",
                placeholder: _vm.trans("blog.category"),
              },
              domProps: { value: _vm.postForm.category },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.postForm, "category", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("show-error", {
              attrs: { "form-name": _vm.postForm, "prop-name": "category" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v(_vm._s(_vm.trans("blog.excerpt")))]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.postForm.excerpt,
                expression: "postForm.excerpt",
              },
            ],
            staticClass: "form-control",
            attrs: {
              rows: "3",
              name: "excerpt",
              placeholder: _vm.trans("blog.excerpt"),
            },
            domProps: { value: _vm.postForm.excerpt },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.postForm, "excerpt", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("show-error", {
            attrs: { "form-name": _vm.postForm, "prop-name": "excerpt" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v(_vm._s(_vm.trans("blog.body")))]),
          _vm._v(" "),
          _c("html-editor", {
            attrs: {
              name: "body",
              model: _vm.postForm.body,
              isUpdate: !!_vm.id,
            },
            on: {
              "update:model": function ($event) {
                return _vm.$set(_vm.postForm, "body", $event)
              },
              clearErrors: function ($event) {
                return _vm.postForm.errors.clear("body")
              },
            },
          }),
          _vm._v(" "),
          _c("show-error", {
            attrs: { "form-name": _vm.postForm, "prop-name": "body" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-6 form-group" },
          [
            _c("label", [_vm._v(_vm._s(_vm.trans("blog.status")))]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.postForm.status,
                    expression: "postForm.status",
                  },
                ],
                staticClass: "form-control",
                attrs: { name: "status" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.postForm,
                      "status",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              [
                _c("option", { attrs: { value: "draft" } }, [
                  _vm._v(_vm._s(_vm.trans("blog.draft"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "published" } }, [
                  _vm._v(_vm._s(_vm.trans("blog.published"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("show-error", {
              attrs: { "form-name": _vm.postForm, "prop-name": "status" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-6 form-group" },
          [
            _c("label", [_vm._v(_vm._s(_vm.trans("blog.published_at")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.postForm.published_at,
                  expression: "postForm.published_at",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "datetime-local", name: "published_at" },
              domProps: { value: _vm.postForm.published_at },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.postForm, "published_at", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("show-error", {
              attrs: { "form-name": _vm.postForm, "prop-name": "published_at" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "admin-plan-form__actions" },
        [
          _c(
            "button",
            {
              staticClass:
                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
              attrs: { type: "submit" },
            },
            [
              _c("admin-icon", { attrs: { name: "check" } }),
              _vm._v(" "),
              _vm.id
                ? _c("span", [_vm._v(_vm._s(_vm.trans("general.update")))])
                : _c("span", [_vm._v(_vm._s(_vm.trans("general.save")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.id,
                  expression: "id",
                },
              ],
              staticClass: "btn btn-sm admin-form-btn-cancel",
              attrs: { to: "/blog" },
            },
            [_vm._v(_vm._s(_vm.trans("general.cancel")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }